import React from "react";
import {
  FooterContainer,
  FooterContent,
  FooterLogo,
  Footer,
  FooterLicenseContainer,
  LinkContainer,
  FooterLinks,
  FooterBottom,
  FooterContact,
  AddressContainer,
} from "./index.styled";
import { TextContainer } from "../../pages/landing/index.styled";
import logo from "../../assets/images/landing-logo.svg";
import enamadImg from "../../assets/images/enamad.png";
import samandehiImg from "../../assets/images/samandehi-silver.png";
import FooterIcons from "../FooterIcons";
import { env } from "../../.env.js";
import { Link } from "react-router-dom";

const LandingFooter = () => {
  const openInNewTab = (url) => {
    window.open(
      url,
      "Popup",
      "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
    );
  };
  return (
    <Footer>
      <FooterContainer noBreak={"2rem"} className="container">
        <FooterContent>
          <FooterLogo>
            <img src={logo} alt="logo" />
          </FooterLogo>
          <TextContainer
            defP={"3rem"}
            width="350px"
            style={{ marginTop: "0px" }}
          >
            <p>
              با آواشو در هرکجا که باشید، می‌توانید به بهترین شکل ممکن و با
              کمترین هزینه متن‌ها را به گفتار تبدیل کنید.
            </p>
          </TextContainer>
          <FooterLicenseContainer>
            <div>
              <a
                href="https://trustseal.enamad.ir/?id=273000&code=0UtFYNEvL8x6m685OQnw"
                target="_blank"
              >
                <img
                  src="https://Trustseal.eNamad.ir/logo.aspx?id=273000&code=0UtFYNEvL8x6m685OQnw"
                  alt=""
                  id="0UtFYNEvL8x6m685OQnwgit"
                />
              </a>
            </div>
            <div>
              <img
                referrerPolicy="origin"
                id="rgvjjxlzapfuoeuksizpapfu"
                style={{ cursor: "pointer", width: "100px", height: "120px" }}
                onClick={() =>
                  openInNewTab(
                    "https://logo.samandehi.ir/Verify.aspx?id=315895&p=xlaorfthdshwmcsipfvldshw"
                  )
                }
                alt="logo-samandehi"
                src="https://logo.samandehi.ir/logo.aspx?id=315895&p=qftinbpdujynaqgwbsiyujyn"
                // src={samandehiImg}
              />
            </div>
          </FooterLicenseContainer>
        </FooterContent>
        <LinkContainer>
          <h3>لینک‌های پرکاربرد</h3>
          <FooterLinks>
            <li>
              <a href={env.REACT_APP_PARTAI_REDIRECT}>
                مرکز تحقیقات هوش مصنوعی پارت
              </a>
            </li>
            <li>
              <a href={env.REACT_APP_PANEL_REDIRECT}>دموی آواشو</a>
            </li>
            <li>
              <a href={env.REACT_APP_AVANEGAR_REDIRECT}>
                آوانگار؛ سرویس تبدیل صوت به متن
              </a>
            </li>
            <li>
              <Link to="/rules">قوانین و مقررات </Link>
            </li>
          </FooterLinks>
        </LinkContainer>

        <FooterContact>
          <h3>تماس با ما</h3>
          <AddressContainer>
            <p>
              تهران، میدان کاج، خیابان سرو شرقی، خیابان مجد کوچه نسترن، پلاک ۳۴
            </p>
          </AddressContainer>
          <AddressContainer>
            <p>شماره پشتیبانی : ۷۴۳۱۸۸۳۵ - ۰۲۱</p>
          </AddressContainer>
          <AddressContainer>
            <p>شماره فروش : ۷۴۳۱۸۰۵۰ - ۰۲۱</p>
          </AddressContainer>
          <AddressContainer>
            <span>ایمیل فروش: </span>
            <a href="mailto:market@partdp.ir">market@partdp.ir</a>
          </AddressContainer>

          <FooterIcons />
        </FooterContact>
      </FooterContainer>

      <FooterBottom>
        <div>
          <span>
            تمامی حقوق و محتوا برای{" "}
            <a href={env.REACT_APP_PARTDB_REDIRECT}>
              مرکز تحقیقات هوش مصنوعی پارت
            </a>{" "}
            محفوظ است.
          </span>
        </div>
      </FooterBottom>
    </Footer>
  );
};

export default LandingFooter;
